import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type HomeInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function HomeInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: HomeInactiveIconProps) {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M22.904 8.796l-7.552-4.693a2.6 2.6 0 00-2.756 0L5.044 8.822a2.6 2.6 0 00-1.183 2.6l1.95 11.698a2.6 2.6 0 002.6 2.171H19.59a2.6 2.6 0 002.6-2.17l1.949-11.7a2.599 2.599 0 00-1.235-2.625z"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </Svg>
  );
}

export default HomeInactiveIcon;
